<template>
  <div class="gold_box">
    <h3 class="activeR">充值德乙币</h3>
    <b class="fz">账户余额：<b class="activeR">0 德乙币</b></b>
    <el-divider></el-divider>
    <div class="pay_money">
      <b class="fz">充值德乙币:</b>
      <div>
        <el-radio
          v-for="(item, index) in pay_obj"
          :key="index"
          v-model="pay_radio"
          :label="index"
          >{{ item }}德乙币</el-radio
        >
        <el-input
          v-if="pay_radio === 7"
          v-model="pay_custom"
          :maxlength="6"
          :minlength="1"
          size="mini"
        ></el-input>
      </div>
      <div class="pay_way">
        <b>支付方式：</b>
        <ul>
          <li
            class="cuP"
            :class="{ alipay: payWay === 1 }"
            @click="payWayFn(1)"
          >
            微信支付
          </li>
          <li
            class="cuP"
            :class="{ alipay: payWay === 2 }"
            @click="payWayFn(2)"
          >
            支付宝支付
          </li>
        </ul>
      </div>
      <el-divider></el-divider>
      <div class="amountPayable">
        <b
          >应付金额:<b class="activeR">{{ pay_money }}</b
          >元</b
        >
        <el-button type="warning" @click="fnDetermineTheTop_up"
          >确定充值</el-button
        >
        <el-dialog
          v-model="dialogVisible"
          width="200px"
          center
          :destroy-on-close="true"
          @close="close_dialog"
        >
          <div class="tit">
            <b class="activeR">请用微信支付</b>
          </div>
          <div id="qrcode" ref="qrcode"></div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import {
  getCurrentInstance,
  ref,
  reactive,
  watch,
  nextTick,
  onUnmounted,
  inject
} from 'vue'
import QRCode from 'qrcodejs2'
export default {
  setup() {
    // 刷新
    const refresh = inject('reload')
    let { proxy: _this } = getCurrentInstance()
    let qs = require('qs')
    let pay_money = ref(6)
    let pay_custom = ref('')
    let pay_radio = ref(0)
    let pay_obj = reactive([60, 200, 500, 1000, 5000, 10000, 50000, '自定义'])
    // 金额
    watch([pay_custom, pay_radio], (n) => {
      if (n[1] === 7) {
        var reg =
          /(^[1-9]([0-9]+)?(\.[0-9]{1,2})?$)|(^(0){1}$)|(^[0-9]\.[0-9]([0-9])?$)/
        if (!reg.test(n[0])) {
          pay_custom.value = ''
          _this.$notify({
            title: '提示',
            message: '请正确输入数值！',
            type: 'error'
          })
        } else if (n[0].length >= 6) {
          _this.$notify({
            title: '提示',
            message: '最大6位整数！',
            type: 'error'
          })
        }
        pay_money.value = pay_custom.value / 10
      } else {
        pay_custom.value = ''
        pay_money.value = pay_obj[n[1]] / 10
      }
    })
    // 支付方式
    let payWay = ref(1)
    let payWayFn = (v) => {
      if (v === 2) {
        return _this.$notify({
          title: '提示',
          message: '暂不支持支付宝支付',
          type: 'error'
        })
      }
      payWay.value = v
    }
    // 支付订单生成
    // let AUTH_TOKEN = window.localStorage.getItem('AUTH_TOKEN')
    let pay_bi = async () => {
      let { data: res } = await _this.$http.post(
        `/auth/user/pay_bi`,
        qs.stringify({ total: pay_money.value, pay_type: payWay.value })
      )
      nextTick(() => {
        new QRCode('qrcode', {
          width: 150,
          height: 150, // 高度
          text: res.data.code_url
        })
      })
      if (res.data.out_trade_no) {
        we_chat_pay(res.data.out_trade_no)
      }
    }
    // 微信订单状态
    let timer = ref(0)
    let we_chat_pay = (out_trade_no) => {
      timer.value = setInterval(async () => {
        let { data: res } = await _this.$http.post(
          `/auth/user/we_chat_pay`,
          qs.stringify({ out_trade_no: out_trade_no })
        )
        if (res.code === 200) {
          if (res.data.pay_status > 0) {
            clearInterval(timer.value)
            _this.$notify({
              title: '提示',
              message: res.message,
              type: 'warning'
            })
            refresh()
          }
        }
      }, 1000)
    }

    // 确定充值
    let dialogVisible = ref(false)
    let fnDetermineTheTop_up = () => {
      if (pay_money.value <= 0) {
        return _this.$notify({
          title: '提示',
          message: '充值金额不能为0',
          type: 'error'
        })
      }
      dialogVisible.value = true
      pay_bi()
    }
    // 关闭定时器
    onUnmounted(() => {
      clearInterval(timer.value)
    })
    let close_dialog = () => {
      clearInterval(timer.value)
    }
    return {
      pay_money,
      pay_radio,
      pay_obj,
      pay_custom,
      fnDetermineTheTop_up,
      payWayFn,
      payWay,
      dialogVisible,
      close_dialog
    }
  }
}
</script>

<style scoped lang="less">
.gold_box {
  h3 {
    margin-bottom: 10px;
    font-weight: 600;
  }
  b {
    color: #000;
    font-size: 14px !important;
  }
  .el-input {
    width: 100px;
    height: 25px;
    border-radius: 0;
    margin-top: -3px;
    .el-input__inner {
      border-radius: 0;
      height: 25px;
      line-height: 25px;
    }
  }
  .pay_way {
    ul {
      display: flex;
      align-items: center;
      li {
        width: 100px;
        height: 30px;
        border: 1px solid #eee;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        margin: 10px 10px 0 10px;
      }
      .alipay {
        border: 2px #ff6500 solid;
        color: #000;
        background: url('../../../../assets/dui.gif') no-repeat right bottom;
      }
    }
  }
  .amountPayable {
    .el-button {
      margin-left: 20px;
    }
    .tit {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50px;
      margin-top: -50px;
    }
  }
}
</style>
